<template>
  <div id="hero">
    <header class="masthead">
      <div class="container">
        <div class="masthead-subheading">Welcome To Our Studio!</div>
        <div class="masthead-heading text-uppercase">It's Nice To Meet You</div>
        <a
          class="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
          href="#services"
        >Tell Me More</a>
      </div>
    </header>
  </div>
</template>

<script>
    export default {
        name: "hero",
    };
</script>

<style lang="scss" scoped>
</style>